export default {
    namespaced: true,
    state: {
        areaCode: "",
    },
    getters: {
        countriesAndRegions: state => { return state.areaCode; },
    },
    mutations: {
        countriesAndRegions(state, val) { state.areaCode = val; }
    }
}